import { css } from '@emotion/css';
import colors from '@/theme/colors';
import { pxToRem } from '@/utils';

const styles = {
  textfield: css`
    & .MuiInputLabel-root {
      font-family: 'Montserrat Regular';
      line-height: 1.33;
      letter-spacing: -0.1px;
      color: ${colors.charcoal} !important;
    }

    & input {
      font-family: 'Montserrat Regular';
      color: ${colors.prussian};
      font-size: ${pxToRem(16)};
      line-height: 1.5;
      letter-spacing: -0.3px;
      &::placeholder {
        color: ${colors.charcoal};
        opacity: 1;
      }
    }

    & .MuiInput-underline:after {
      border-bottom: 2px solid ${colors.prussian};
    }
    .MuiInput-underline.Mui-error:after {
      border-bottom-color: ${colors.dragon} !important;
    }
    .MuiFormHelperText-root {
      font-family: 'Montserrat Regular';
      font-size: ${pxToRem(12)};
      line-height: 1.33;
      letter-spacing: -0.3px;
      color: ${colors.dragon} !important;
    }
    & .MuiInputLabel-asterisk {
      color: ${colors.dragon} !important;
    }
  `,
};

export default styles;
